import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const DeliverFiles = ({ readOnly, task, refetch }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    if (confirm(formatMessage(messages.deliverFilesConfirm))) {
      fetch(`/ordertask/deliver.json?taskId=${task.uid}`, { 
        method: 'POST'
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          toastr.success(formatMessage(messages.deliverFilesSuccess))
        } else {
          toastr.error(formatMessage(messages.deliverFilesError, { errors: response.errors.join(', ') }))
        }
      })
      .catch((error) => toastr.error(error))
      .finally(() => {refetch()})
    }
  }

  return (
    <Menu.Item key='deliverFiles' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          { formatMessage(messages.deliverFiles) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default DeliverFiles
